import GlobalLoginV2, { viewType } from './GlobalLoginV2';

export default GlobalLoginV2;
export { viewType };
